<template>
    <div>
        <a-page-header style="border: 1px solid rgb(235, 237, 240)" :ghost="false" title="Report">
        </a-page-header>

        <div v-for="item in dataReport" :key="item.title">
            <a-card type="inner" size="small" :title="item.title" style="margin-bottom: 12px" bordered>
                <template v-for="(detail, index) in item.report">
                    <a-row type="flex" :gutter="[8]" :key="detail.title">
                        <template v-if="detail.access == true">
                            <a-col :span="1" style="text-align: right">
                                {{ (index+1) }}.
                            </a-col>
                            <a-col :span="20">
                                <a :href="detail.route">
                                    {{ detail.title }}
                                </a>
                            </a-col>
                        </template>
                    </a-row>
                </template>
            </a-card>
        </div>
    </div>
</template>

<script>
export default {
    computed: {
        activeModule() {
            return this.$laravel.active_module
        },
        role(){
            return this.$laravel.roles[this.activeModule.module.identifier]
        },
        dataReport() {
            let collection = [
                {
                    title: "KLASIKAL",
                    report: [
                        {
                            title: "Rangking Pencapaian Pelatihan Berdasar Nilai Tertinggi",
                            route: this.routeUri("admin.classical.report.highest_score"),
                            access: this.canAccess("KLASIKAL-1")
                        }, {
                            title: "Nilai Rata-Rata Peserta Per Materi Pelatihan",
                            route: this.routeUri("admin.classical.report.material_avg"),
                            access: this.canAccess("KLASIKAL-1")
                        }, {
                            title: "Nilai Peserta Berdasarkan Materi",
                            route: this.routeUri("admin.classical.report.material-breakdown"),
                            access: this.canAccess("KLASIKAL-1")
                        }, {
                            title: "Nilai Rata-Rata Pertumbuhan Peserta terhadap Pre Test & Post Test",
                            route: this.routeUri("admin.classical.report.exam-growth"),
                            access: this.canAccess("KLASIKAL-1")
                        }
                    ]
                },
                {
                    title: "MAKALAH",
                    report: [
                        {
                            title: "Report Nilai Makalah",
                            route: this.routeUri("admin.paper.report.paper_score") + '?module=paper',
                            access: this.canAccess("MAKALAH-1")
                        },
                        {
                            title: "Rekap Nilai Makalah Berdasar Nilai Tertinggi",
                            route: this.routeUri("admin.paper.report.highest_score") + '?module=paper',
                            access: this.canAccess("MAKALAH-2")
                        },
                        {
                            title: "SLA Bimbingan",
                            route: this.routeUri("admin.paper.sla") + '?module=paper',
                            access: this.canAccess("MAKALAH-3")
                        }
                    ]
                },
                /**
                {
                    title: "PROJECT MANAGEMENT",
                    report: [
                        {
                            title: "Report Nilai Project Management",
                            route: this.routeUri("admin.project.report.project_score") + '?module=project',
                            access: this.canAccess("PROJECT-1")
                        },
                        {
                            title: "Rekap Nilai Project Management Berdasar Nilai Tertinggi",
                            route: this.routeUri("admin.project.report.project_highest_score") + '?module=project',
                            access: this.canAccess("PROJECT-2")
                        },
                        {
                            title: "SLA Bimbingan",
                            route: this.routeUri("admin.project.sla") + '?module=project',
                            access: this.canAccess("PROJECT-3")
                        }
                    ]
                },
                {
                    title: "PERFORMANCE",
                    report: [
                        {
                            title: "Report Nilai Business Performance",
                            route: this.routeUri(""),
                            access: this.canAccess("PERFORMANCE-1")
                        },
                        {
                            title: "Report Nilai Business Performance Berdasar Nilai Tertinggi",
                            route: this.routeUri(""),
                            access: this.canAccess("PERFORMANCE-2")
                        },
                        {
                            title: "Report Pelaksanaan Business Performance",
                            route: this.routeUri(""),
                            access: this.canAccess("PERFORMANCE-3")
                        },
                        {
                            title: "Report Pertumbuhan Sales Tabungan",
                            route: this.routeUri(""),
                            access: this.canAccess("PERFORMANCE-4")
                        },
                        {
                            title: "Report Pertumbuhan Sales Giro",
                            route: this.routeUri(""),
                            access: this.canAccess("PERFORMANCE-5")
                        },
                        {
                            title: "Report Pertumbuhan Sales Deposito",
                            route: this.routeUri(""),
                            access: this.canAccess("PERFORMANCE-6")
                        },
                        {
                            title: "Report Presentase Pencapaian Target Sales Funding",
                            route: this.routeUri(""),
                            access: this.canAccess("PERFORMANCE-7")
                        },
                        {
                            title: "Report Pertumbuhan Penyelesaian Kredit Gol 3,4,5",
                            route: this.routeUri(""),
                            access: this.canAccess("PERFORMANCE-8")
                        },
                        {
                            title: "Report Pemasaran Kredit UMKM",
                            route: this.routeUri(""),
                            access: this.canAccess("PERFORMANCE-9")
                        },
                        {
                            title: "Report Presentase Pencapaian Target Sales Lending",
                            route: this.routeUri(""),
                            access: this.canAccess("PERFORMANCE-10")
                        }
                    ]
                },
                {
                    title: "EVALUASI KINERJA",
                    report: [
                        {
                            title: "Nilai Evaluasi Kinerja",
                            route: this.routeUri('admin.evaluation.report.evaluation_score') + '?module=evaluation',
                            access: this.canAccess("EVALUATION-1")
                        },
                        {
                            title: "Rekap Nilai Evaluasi Kinerja Berdasar Nilai Tertinggi",
                            route: this.routeUri('admin.evaluation.report.evaluation_highest_score') + '?module=evaluation',
                            access: this.canAccess("EVALUATION-2")
                        }
                    ]
                },
                 **/
                {
                    title: "GABUNGAN",
                    report: [
                        {
                            title: "Report Penilaian Seluruh Nilai : Klasikal, Makalah, Project Management, Performance,Evaluasi Kinerja",
                            route: this.routeUri('admin.training.report.training_score'),
                            access: this.canAccess("GABUNGAN-1")
                        },
                        {
                            title: "Rangking Penilaian Peserta Berdasar Nilai Tertinggi",
                            route: this.routeUri('admin.training.report.training_highest_score') + '?module=training',
                            access: this.canAccess("GABUNGAN-2")
                        }
                    ]
                },
            ]

            return collection
        }
    },
    methods: {
        canAccess(module) {
                var role
                let vm = this

                if(module === "KLASIKAL-1")
                    role = [ 'inspirator', 'project-manager', 'project-owner', 'project-manager-client', 'project-owner-client', 'project-sponsor', 'admin']

                if(module === "KLASIKAL-2")
                    role = [ 'inspirator', 'project-manager', 'project-owner', 'project-manager-client', 'project-owner-client', 'project-sponsor', 'admin']

                if(module === "MAKALAH-1")
                    role = ['attendant', 'project-manager', 'project-owner', 'project-manager-client', 'project-owner-client', 'project-sponsor', 'admin']

                if(module === "MAKALAH-2")
                    role = ['attendant', 'project-manager', 'project-owner', 'project-manager-client', 'project-owner-client', 'project-sponsor', 'admin']

                if(module === "MAKALAH-3")
                    role = ['admin']

                if(module === "PROJECT-1")
                    role = ['attendant', 'project-manager', 'project-owner', 'project-manager-client', 'project-owner-client', 'project-sponsor', 'admin']

                if(module === "PROJECT-2")
                    role = ['attendant', 'project-manager', 'project-owner', 'project-manager-client', 'project-owner-client', 'project-sponsor', 'admin']

                if(module === "PROJECT-3")
                    role = ['admin']

                if(module === "PERFORMANCE-1")
                    role = ['attendant', 'project-manager', 'project-owner', 'project-manager-client', 'project-owner-client', 'project-sponsor', 'admin']

                if(module === "PERFORMANCE-2")
                    role = ['attendant', 'project-manager', 'project-owner', 'project-manager-client', 'project-owner-client', 'project-sponsor', 'admin']

                if(module === "PERFORMANCE-3")
                    role = ['project-manager', 'project-owner', 'project-manager-client', 'project-owner-client', 'project-sponsor', 'admin']

                if(module === "PERFORMANCE-4")
                    role = ['project-manager', 'project-owner', 'project-manager-client', 'project-owner-client', 'project-sponsor', 'admin']

                if(module === "PERFORMANCE-5")
                    role = ['project-manager', 'project-owner', 'project-manager-client', 'project-owner-client', 'project-sponsor', 'admin']

                if(module === "PERFORMANCE-6")
                    role = ['project-manager', 'project-owner', 'project-manager-client', 'project-owner-client', 'project-sponsor', 'admin']

                if(module === "PERFORMANCE-7")
                    role = ['project-manager', 'project-owner', 'project-manager-client', 'project-owner-client', 'project-sponsor', 'admin']

                if(module === "PERFORMANCE-8")
                    role = ['project-manager', 'project-owner', 'project-manager-client', 'project-owner-client', 'project-sponsor', 'admin']

                if(module === "PERFORMANCE-9")
                    role = ['project-manager', 'project-owner', 'project-manager-client', 'project-owner-client', 'project-sponsor', 'admin']

                if(module === "PERFORMANCE-10")
                    role = ['project-manager', 'project-owner', 'project-manager-client', 'project-owner-client', 'project-sponsor', 'admin']

                if(module === "EVALUATION-1")
                    role = ['attendant', 'project-manager', 'project-owner', 'project-manager-client', 'project-owner-client', 'project-sponsor', 'admin']

                if(module === "EVALUATION-2")
                    role = ['attendant', 'project-manager', 'project-owner', 'project-manager-client', 'project-owner-client', 'project-sponsor', 'admin']

                if(module === "GABUNGAN-1")
                    role = ['project-manager', 'project-owner', 'project-manager-client', 'project-owner-client', 'project-sponsor', 'admin']

                if(module === "GABUNGAN-2")
                    role = ['project-manager', 'project-owner', 'project-manager-client', 'project-owner-client', 'project-sponsor', 'admin']

                var grants = role.filter(function(ele){
                    return (ele == vm.role)
                });

                return grants.length > 0

        }
    }
}
</script>
